import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-expand",
  "use": "icon-expand-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-expand\"><path d=\"m6 9.293.707.707L13 3.707V6h1V2h-4v1h2.293z\" /><path d=\"M11 9v3a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6c0-.551.448-1 1-1h4V4H4c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h6c1.1 0 2-.9 2-2V9z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol